export const TOKEN_QUERY_PARAM = 'invitation_token';
export const EMAIL_QUERY_PARAM = 'email';
export const PRODUCT_TO_REDIRECT_PARAM = 'redirect_to_product';
const REFERRER_SOURCE = 'referrer';
const WEBSITE_LOGIN_BUTTON_REFERRER_VALUE = 'website-login';

export enum REDIRECT_TO_PRODUCT_VALUE {
	MOBILE_SDK = 'mobile_sdk',
	MOBILE_FLOW_ANALYZER = 'mobile_flow_analyzer',
	SITE_SCANNER = 'site_scanner'
}
const getQueryParams = (): URLSearchParams => {
	return new URLSearchParams(window.location.search);
};
const getHashParams = (): URLSearchParams => {
	return new URLSearchParams(window.location.hash);
};

const getQueryParam = (paramName: string): string => {
	return getQueryParams().get(paramName);
};

const getParamFromQueryOrHash = (paramName: string): string => {
	const tokenFromParams = getQueryParam(paramName);
	if (tokenFromParams) {
		return tokenFromParams;
	}
	// if the URL is redirected from Auth0 signup activation page,
	// the param will be in the hash (after #)
	return getHashParams().get(paramName);
};

export const getInvitationTokenFromUrl = (): string => {
	return getParamFromQueryOrHash(TOKEN_QUERY_PARAM);
};

export const getEmailFromUrl = (): string => {
	return getParamFromQueryOrHash(EMAIL_QUERY_PARAM);
};

export const getProductToRedirectFromUrl = (): REDIRECT_TO_PRODUCT_VALUE | undefined => {
	const redirectionValue = getParamFromQueryOrHash(PRODUCT_TO_REDIRECT_PARAM);
	// only let known products through, the param comes straight from the url
	return Object.values(REDIRECT_TO_PRODUCT_VALUE).includes(
		redirectionValue as REDIRECT_TO_PRODUCT_VALUE
	)
		? (redirectionValue as REDIRECT_TO_PRODUCT_VALUE)
		: undefined;
};

export const shouldHideSignupOption = (): boolean => {
	const origin = getQueryParam(REFERRER_SOURCE);
	return origin === WEBSITE_LOGIN_BUTTON_REFERRER_VALUE;
};
